import { capabilities } from 'navigation-components/capabilities';
import { useCapability } from 'navigation-components/platform/hooks';
import { useEffect } from 'react';
import { useNavBookmarks } from '../useNavBookmarks/useNavBookmarks';
export const useAddToBookmarks = () => {
  const {
    subscribe
  } = useCapability(capabilities.ADD_TO_BOOKMARKS_CAP.getName());
  const {
    addNavItemToBookmarks
  } = useNavBookmarks();
  useEffect(() => {
    const unsubscribe = subscribe(({
      path,
      id
    }) => {
      addNavItemToBookmarks({
        path,
        id
      });
    });
    return unsubscribe;
  }, [addNavItemToBookmarks, subscribe]);
};